type UrlMap = {
  [key: string]: string
}

const urlMap: UrlMap = {
  es: 'https://hooks.zapier.com/hooks/catch/14891650/3ht0bnk/',
  it: 'https://hooks.zapier.com/hooks/catch/14891650/3htppl0/',
  fr: 'https://hooks.zapier.com/hooks/catch/14891650/3hde66w/',
  de: 'https://hooks.zapier.com/hooks/catch/14891650/3hdep8c/',
  gb: 'https://hooks.zapier.com/hooks/catch/14891650/3hdxomt/',
  ie: 'https://hooks.zapier.com/hooks/catch/14891650/3hdxomt/',
  pt: 'https://hooks.zapier.com/hooks/catch/14891650/3hdpqzs/',
  us: 'https://hooks.zapier.com/hooks/catch/14891650/3hdnkvi/',
  ca: 'https://hooks.zapier.com/hooks/catch/14891650/3hdnkvi/',
  mx: 'https://hooks.zapier.com/hooks/catch/14891650/3hdnpmq/',
  br: 'https://hooks.zapier.com/hooks/catch/14891650/3hd72ln/',
  co: 'https://hooks.zapier.com/hooks/catch/14891650/3hd7560/',
  default: 'https://hooks.zapier.com/hooks/catch/14891650/3ht0bnk/',
}

export const getUrl = (lang: string): string => (urlMap[lang] || urlMap.default) as string
